import { render } from "./InfoPage.vue?vue&type=template&id=101876a9&scoped=true"
import script from "./InfoPage.vue?vue&type=script&lang=js"
export * from "./InfoPage.vue?vue&type=script&lang=js"

import "./InfoPage.vue?vue&type=style&index=0&id=101876a9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-101876a9"]])

export default __exports__